import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { combineLatestWith, map } from 'rxjs';
import { SortStringPipe } from 'src/app/shared/pipes/sort-string/sort-string.pipe';
import { MenuListRepository } from 'src/app/shared/repositories/menu-list.repository';
import { SessionRepository } from 'src/app/shared/repositories/session.repository';

@Component({
  selector: 'app-filter-bar',
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SortStringPipe,
  ]
})
export class FilterBarComponent {
  constructor(
    private menuRepository: MenuListRepository,
    private sessionRepository: SessionRepository
  ) { }

  labelFilterItems$ = this.menuRepository.labelList$.pipe(
    combineLatestWith(this.sessionRepository.activeLabelFilter$),
    map(([list, activeFilter]) =>
      list?.map(label => ({
        name: label,
        isActive: activeFilter?.includes(label)
      }))
    )
  );

  allergenFilterItems$ = this.menuRepository.allergenList$.pipe(
    combineLatestWith(this.sessionRepository.activeAllergenFilter$),
    map(([list, activeFilter]) =>
      list?.map(allergen => ({
        name: allergen,
        isActive: activeFilter?.includes(allergen)
      }))
    )
  );

  toggleLabelFilterItem(item: string) {
    this.sessionRepository.toggleActiveLabelFilter(item);
  }

  toggleAllergenFilterItem(item: string) {
    this.sessionRepository.toggleActiveAllergenFilter(item);
  }
}
